import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import {navigator} from 'lit-element-router';
import store from '../../store';
import next from '../../../icons/next';
import reset from '../../../icons/reset';
import info from '../../../icons/info';

import {setSection} from '../../slices/statusSlice';
import {routeUrl} from '../../util/routeUrl';

@customElement('solar-start')
export class SolarStart extends connect(store)(navigator(LitElement)) {

	static styles = [
		css`
			:host {
				width: var(--assistant-widget-width);
			}
			.title {
				display: flex;
				align-items: center;
				font: var(--font-widget-big-title);
				color: var(--color-widget-text);
				line-height: 1.4;
				margin-bottom: 40px;
			}
			.description {
				font: var(--font-widget-label);
				color: var(--color-widget-text);
				line-height: 1.4;
				margin-bottom: 40px;
			}
			button,.button {
				display: flex;
				gap: var(--small-padding);
				align-items: center;
				justify-content: center;
				flex-direction: row;

				font-family: var(--font-family-light);
				font-size: var(--font-size-widget);
				color: var(--color-widget-text);
				height: var(--nav-button-height);
				width: 100%;
				letter-spacing: 1px;
				background-color: var(--color-widget-background);
				border: none;
				cursor: pointer;
				line-height: 0;
				transition: background-color 0.4s ease-out, color 0.4s ease-out;
				text-decoration: none;
				margin-bottom: var(--small-padding);
			}
			button:hover, .button:hover  {
				background-color: var(--color-widget-background-hover);
			}
			.icon {
				display: inline-block;
				max-width: 20px;
				color: var(--color-widget-text);
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
	}
	onClick() {
		store.dispatch(
			setSection({currentSection: 'location'})
		);
	}
	onReset() {
		this.navigate(routeUrl({media: 'sections', key: 'new'}));
		window.location.reload();
	}
	render() {
		const s = store.getState();

		return html`
			<div>
				<div class="title">
					${msg('Configure the new efficient Aeto solar luminaire for your project.')}
				</div>
				<div class="description">
					${msg('Aeto adapts flexibly to environmental and project requirements. Use our configurator to determine possible light outputs depending on the size of the solar unit based on statistical sun and weather data from at least the last 10 years.')}
				</div>
				<button @click=${this.onClick}>
					${msg('Start Configuration')}
					<span class="icon">${next}</span>
				</button>
				<button @click=${this.onReset}>
					${msg('Reset Configuration')}
					<span class="icon">${reset}</span>
				</button>
				<a class="button" href="https://www.selux.com/int/${this.lang}/landing/aeto-consultation" target="_blank">
					${msg('Personal Consultation')}
					<span class="icon">${info}</span>
				</a>
			</div>

		`;
	}
}
